<template>
  <span class="bz-beta-wrap" v-click-outside="close">
    <button class="bz-beta" type="button" @click="open = !open">
      <i class="material-icons" style="font-size:13px;line-height:1;">science</i>
      Beta
      <i class="material-icons" style="font-size:13px;line-height:1;">expand_more</i>
    </button>
    <div v-if="open" class="bz-pop">
      <div class="bz-pop-title">You're using the new selector</div>
      <p>Prefer the classic version? Switch back anytime — we remember your choice on this account, across devices.</p>
      <div v-if="saved" class="bz-pop-saved">
        <i class="material-icons" style="font-size:15px;line-height:1;">check_circle</i>
        Preference saved — switching to classic…
      </div>
      <button v-else class="bz-btn ghost" type="button" @click="switchToClassic">
        <i class="material-icons" style="font-size:15px;line-height:1;">history</i>
        Switch to classic selector
      </button>
      <button class="bz-pop-close" type="button" @click="open = false">
        <i class="material-icons" style="font-size:14px;line-height:1;">close</i>
      </button>
    </div>
  </span>
</template>

<script>
import { setSelectorOverride } from './flag';

// Report products share the gate route with their research profile, so a plain
// reload lands them on the classic PROFILE selector (NewProfile/NewMarketProfile
// render the research profile) instead of the analysis-report selector. Reports
// must navigate to the classic report-creation wizard for their type — the
// reverse of the forward TryBetaPill's REPORT_ROUTE map.
const REPORT_PARAM = {
  financial_report: 'financial',
  market_report: 'market',
  valuation_report: 'valuation',
  company_report: 'company',
};

export default {
  name: 'beta-pill',
  props: { product: { type: String, required: true } },
  data() {
    return { open: false, saved: false };
  },
  methods: {
    async switchToClassic() {
      this.saved = true;
      await setSelectorOverride(this.product, 'classic');
      const reportParam = REPORT_PARAM[this.product];
      if (reportParam) {
        // send reports to the classic report wizard for their type (carrying
        // the chosen input set), NOT a reload into the research-profile page
        const dataId = this.$route.query['data-id'];
        const query = dataId ? { 'data-id': String(dataId) } : {};
        this.$router.push({ name: 'CreateReportFormat', params: { report: reportParam }, query }).catch(() => {});
      } else {
        // profile selectors reload in place — the gate re-renders classic
        setTimeout(() => window.location.reload(), 500);
      }
    },
    close() {
      this.open = false;
    },
  },
  directives: {
    // minimal click-outside; avoids depending on the app's mixed plugins
    clickOutside: {
      bind(el, binding) {
        el.__bzClickOutside__ = (e) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener('click', el.__bzClickOutside__);
      },
      unbind(el) {
        document.removeEventListener('click', el.__bzClickOutside__);
      },
    },
  },
};
</script>
